export { default } from "bullitttime-embercomponents/components/event-selector";
